import { y as lib } from "./index.js";
export { z as default } from "./index.js";
var rest = lib.rest;
export { rest };
